import './pages/index';
import './pages/show';



// WEBPACK FOOTER //
// ./modules/teams/index.js